// extracted by mini-css-extract-plugin
export var cardIcon = "_5y-5";
export var cardIconUnframed = "_5y-9";
export var checkboxCard = "_5y-0";
export var checkboxCardSelected = "_5y-4";
export var disabled = "_5y-2";
export var interactive = "_5y-1";
export var outerBorder = "_5y-3";
export var spacerMedium = "_5y-8";
export var spacerSmall = "_5y-7";
export var spacerXsmall = "_5y-6";